import React from "react";
import { FlexibleContainer } from "../containers/styledComponents";
import { CompassParagraph } from "../common/styledComponents";
import { LegendCircle } from "./styledComponents";
import { Filter } from "../../types/PageFilterTypes";
import { TaskPriority } from "../../models/workflowModels";
import { Priority } from "../../enums/Status";

export const PRIORITY_COLORS: { [key in TaskPriority]: string } = {
  [TaskPriority.LOW]: "#28dd8d",
  [TaskPriority.MEDIUM]: "#fac300",
  [TaskPriority.HIGH]: "#ef5d4e",
};

export const PRIORITY_MAPPING: { [key in TaskPriority]: Priority } = {
  [TaskPriority.HIGH]: Priority.HIGH,
  [TaskPriority.MEDIUM]: Priority.MEDIUM,
  [TaskPriority.LOW]: Priority.LOW,
};

export const PriorityIndicator = ({
  priority,
}: {
  priority: TaskPriority;
}): JSX.Element => {
  return (
    <FlexibleContainer ai="center" jc="flex-start">
      <LegendCircle color={PRIORITY_COLORS[priority]} size={12} />
      <CompassParagraph ml={5}>{PRIORITY_MAPPING[priority]}</CompassParagraph>
    </FlexibleContainer>
  );
};

export const buildPriorityOptions = (
  firstKey?: TaskPriority,
  selectorName?: string
): Filter[] => {
  const priorityOptions: Filter[] = [];

  Object.keys(PRIORITY_COLORS).forEach((dataIndex) => {
    priorityOptions.push({
      key: dataIndex,
      displayValue: PRIORITY_MAPPING[dataIndex as TaskPriority],
      component: () => (
        <PriorityIndicator priority={dataIndex as TaskPriority} />
      ),
    });
  });

  if (firstKey) {
    const index = priorityOptions.findIndex((opt) => opt.key === firstKey);
    if (index > -1) {
      const [first] = priorityOptions.splice(index, 1);
      priorityOptions.unshift(first);
    }
  }

  if (selectorName) {
    priorityOptions.forEach((option) => {
      option.selectorName = selectorName;
    });
  }

  return priorityOptions;
};

export const priorityOptions: Filter[] = buildPriorityOptions();
